module.exports = __webpack_public_path__ + "static/img/DSC_2666.ccb6fff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/DSC_2666.jpg
// module id = 270
// module chunks = 0